import { ALIGN, POSITION } from 'components/analyze/analyze-common';

export interface LineSubscription {
    sourceId: string,
    deviceId: string,
    lineId: string,
    displayName: string,
    ltmi: string,
    settings: LineSettings | undefined,
    bulkData: Array<any>,
    data: Array<any>,
    _data: Array<any>
}

// LineSettings contained within TelemetryNode of SourceNodes tree
export interface LineSettings {
    lineColor: string // rgb color
    showSourceName: boolean
    showDeviceName: boolean
    showUoMSymbol: boolean
    showCustomName: boolean
    customName: string
    yAxisPosition: Y_AXIS_POSITION // none, left, right
    minYaxis: number | null
    maxYaxis: number | null
    showTitle: boolean
    function: FUNC_TYPE
    functionTimeframe: number
}

export interface LineWidgetSettings {
    // Contains the entire hierarchy of selected items
    showLegend: boolean;
    showGridLines: boolean;
    title: {
        showTitle: boolean
        text: string
        position: POSITION
        align: ALIGN
        font: {
            weight: string
            size: number
        }
    }
    timeHorizon: TIME_HORIZON;
    timeHorizonDuration: number;
    sourceNodes: Array<any> | undefined; // SourceNodes contain LineSettings
}


export enum Y_AXIS_POSITION {
    NONE = 'none',
    LEFT = 'left',
    RIGHT = 'right'
}

export enum TIME_HORIZON {
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAYS = 'days',
    WEEKS = 'weeks'
}

export enum FUNC_TYPE {
    REALTIME = "realtime",
    AVERAGE = "average",
    MINMAX = "minmax"
}

export interface TimeHorizon {
    id: any;
    local: string;
    label: string;
}
